import { render, staticRenderFns } from "./AppointmentsBlock.vue?vue&type=template&id=82f7d0ac"
import script from "./AppointmentsBlock.vue?vue&type=script&lang=js"
export * from "./AppointmentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports